/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import { Radio } from 'antd'
import { Schema$MarketBlock } from '@protocol/game'
import { OUTCOME_CLASS, RADIO_GROUP_CLASS, TypeProps } from '../OutcomeBlockNew'

export interface UnderOverTypeProps extends TypeProps {
  outcomeHeadOrders: number[]
  overOutcomeIndexes: number[]
  underOutcomeIndexes: number[]
}

const UnderOverType: React.FC<UnderOverTypeProps> = (props: UnderOverTypeProps) => {

  const {
    markets,
    initialOutcomeCount,
    renderOutcomeHeader,
    makeOutcomesElement,
    selectedField,
    outcomeHeadOrders,
    overOutcomeIndexes,
    underOutcomeIndexes,
  } = props

  const viewKeyPrefix = 'OutcomeBlockType:UnderOverType:'

  const renderOutcomes = (market: Schema$MarketBlock, outcomeIndexes: number[]) => {
    const outcomes = []
    for (const index of outcomeIndexes) {
      const outcome = market.outcomes.find(object => object.order === index)
      outcomes.push(outcome)
    }

    const outcomeElements = makeOutcomesElement(market, outcomes)
    return outcomeElements
  }

  return (
    <Fragment>
      <div className={OUTCOME_CLASS.POINT}>
        {renderOutcomeHeader(markets[0], outcomeHeadOrders)}
      </div>

      <div className="outcome-btn-wrap">
        <Radio.Group
          value={selectedField}
          className={initialOutcomeCount % 3 === 0 ? RADIO_GROUP_CLASS.BTN_3_WAY : RADIO_GROUP_CLASS.BTN_2_WAY}
        >
          {markets.map(market => (
            <Fragment key={`${viewKeyPrefix}${market.id}`}>
              <div className="btn-group">
                <div className="match-point">언더 {market.specialBetValue}</div>
                {renderOutcomes(market, underOutcomeIndexes)}
              </div>
              <div className="btn-group">
                <div className="match-point">오버 {market.specialBetValue}</div>
                {renderOutcomes(market, overOutcomeIndexes)}
              </div>
            </Fragment>
          ))}
        </Radio.Group>
      </div>
    </Fragment>
  )
}

export default observer(UnderOverType)
